<template>
  <div class="flex items-center justify-center h-full">
    <vs-chip
      style="height:30px;"
      :color="params.value ? 'success' : 'danger'"
    >
      {{ params.value ? 'نشط' : 'غير نشط' }}
    </vs-chip>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "VolunteerStatusBadge"
});
</script>
